import { render, staticRenderFns } from "./CampaignsAdsGrid.vue?vue&type=template&id=15db92f8&scoped=true"
import script from "./CampaignsAdsGrid.vue?vue&type=script&lang=ts"
export * from "./CampaignsAdsGrid.vue?vue&type=script&lang=ts"
import style0 from "./CampaignsAdsGrid.vue?vue&type=style&index=0&id=15db92f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15db92f8",
  null
  
)

export default component.exports